import React, { useRef, useState, useEffect } from 'react'
import './wallet.sass'
import Header from '../../components/common/Header'
import { VerificationButton, WalletTabBar, Withdraw } from '../../components/wallet'
import { Input } from '../../components/common/Input'
import { ButtonRed } from '../../components/common/Button'
import HeaderBlock from '../../components/common/HeaderBlock'
import { EmptyScreen } from '../../components/common/EmptyScreen'

export default function Wallet() {

    const transactionRef = useRef(0)
    const balanceRef = useRef(0)
    const paymentRef = useRef(0)
    const [verificationStatus, setVerificationStatus] = useState('start');
    const [withdrawConf, setWithdrawConf] = useState(false);

    const [isMobile, setIsMobile] = useState(false);
    const updateView = (v) => {
        if (v <= 830) {
            setIsMobile(true);
            try {
                paymentRef.current.style.display = "none";
                transactionRef.current.style.display = "none";

                balanceRef.current.style.maxWidth = "100%"
                balanceRef.current.style.flex = "100%"
                balanceRef.current.style.paddingRight = "0px"

            } catch (e) { }
        } else {
            setIsMobile(false)
            try {
                transactionRef.current.style.display = "block";
                paymentRef.current.style.display = "block";
                balanceRef.current.style.display = "block";


                balanceRef.current.style.maxWidth = "33.3%"
                balanceRef.current.style.flex = "33.3%"
                balanceRef.current.style.paddingRight = "10px"

                transactionRef.current.style.maxWidth = "33.3%"
                transactionRef.current.style.flex = "33.3%"
                transactionRef.current.style.paddingLeft = "10px"

                paymentRef.current.style.maxWidth = "33.3%"
                paymentRef.current.style.flex = "33.3%"
                paymentRef.current.style.padding = "0px 5px"
            } catch (e) {

            }
        }
        if(v < 580){
            document.getElementById('mobileWrapper').style.display = "none";
        } else {
            document.getElementById('mobileWrapper').style.display = "flex";
        }
    }

    useEffect(() => {
        updateView(window.innerWidth)
        if(bodyWidth < 580){
            document.getElementById('mobileWrapper').style.display = "none";
        } else {
            document.getElementById('mobileWrapper').style.display = "flex";
        }
    }, [])

    window.addEventListener('resize', v => {
        updateView(v.target.innerWidth)

    })


    // useEffect to watch for width height change
	const [bodyWidth, setBodyWidth] = useState(document.body.clientWidth);
    const updateWindowWidth = () => {
        // setBodyHeight(document.body.clientHeight);
        setBodyWidth(document.body.clientWidth);
	}
	
	useEffect(() => {
		window.addEventListener('resize', updateWindowWidth);
		if(bodyWidth < 580){
            document.getElementById('mobileWrapper').style.display = "none";
        } else {
            document.getElementById('mobileWrapper').style.display = "flex";
        }
    }, [bodyWidth]);
    

    const updateTab = (e, setIsActive) => {
        if (e == 0) {
            try {
                balanceRef.current.style.display = "block";
                balanceRef.current.style.maxWidth = "100%"
                balanceRef.current.style.flex = "100%"
                balanceRef.current.style.paddingRight = "0px"
                setIsActive(0);
                paymentRef.current.style.display = "none";
                transactionRef.current.style.display = "none";
            } catch (e) { }
        } else if (e == 1) {
            try {
                paymentRef.current.style.display = "block";
                paymentRef.current.style.maxWidth = "100%"
                paymentRef.current.style.flex = "100%"
                paymentRef.current.style.paddingRight = "0px"
                setIsActive(1);
                transactionRef.current.style.display = "none";
                balanceRef.current.style.display = "none";
            } catch (e) { }
        } else {
            try {
                transactionRef.current.style.display = "block";
                transactionRef.current.style.maxWidth = "100%"
                transactionRef.current.style.flex = "100%"
                transactionRef.current.style.paddingRight = "0px"
                setIsActive(2);
                paymentRef.current.style.display = "none";
                balanceRef.current.style.display = "none";
            } catch (e) { }
        }
    }

    const withdrawMoney = () => {
        setWithdrawConf(!withdrawConf);
    }
    return (
        <div id="walletWrapper">
            {isMobile ? <div id="walletTabBar"> <WalletTabBar title="Wallet" onUpdate={updateTab} text="Wallet Balance" img="tip" text2="Payment Option" img2="creditCard" text3="Transactions" img3="transaction" /> </div> : '' }
            <div id="walletRow">

                <div ref={balanceRef} id="walletLCol">
                    { !isMobile ? <Header img='tip.svg' text="Wallet Balance" />: ''}
                    <p id="walletNormalText">Your available money collected from subscriptions and tips. You can withdraw this balance anytime.</p>
                    <div id="walletTotalBalance">
                        <p id="walletTotalBalanceText">$2345</p>
                    </div>
                    <HeaderBlock img='verified_a.svg' text="Verification Status" />
                    <p id="walletNormalText">Your available money collected from subscriptions and tips. You can withdraw this balance anytime.</p>
                    <VerificationButton status={verificationStatus} />
                    <p id="walletBoldText" style={{marginBottom: '0px'}}>Withdraw Money</p>
                    <p id='walletNormalText' style={{marginTop: '10px', marginBottom: '10px'}}>Your withdraw will be processed. Allow up to 5 business days to receive money.</p>
                    <Input placeholder="Amount of money" icon='tip.svg' type="text" />
                    <div className='withdrawConf'>
                        {withdrawConf ? <img src={require('../../assets/icons/checkbox_a.svg')} onClick={withdrawMoney} alt="checked" /> : <img src={require('../../assets/icons/checkbox.svg')} onClick={withdrawMoney} alt="unchecked" />}
                        <p id="walletNormalText" style={{marginLeft: '10px'}}>Withdrawal confirmation</p>
                    </div>
                    <div className="withdrawButton">
                        <p>WITHDRAW MONEY</p>
                    </div>
                </div>

                <div ref={paymentRef} id="walletCCol">
                    { !isMobile ? <Header img='creditCard.svg' text="Payment Options" />: ''}
                </div>

                <div ref={transactionRef} id="walletRCol">
                    { !isMobile ? <Header img='transaction.svg' text="Transactions" />: ''}
                    {/* <Withdraw status="withdraw" name="Aryan" time="2 days ago @5:30am" amount="36" />
                    <Withdraw status="tip" name="Aryan" time="2 days ago @5:30am" amount="36" />
                    <Withdraw status="subscribe" name="Aryan" time="2 days ago @5:30am" amount="36" />
                    <Withdraw status="withdraw" name="Aryan" time="2 days ago @5:30am" amount="36" />
                    <Withdraw status="tip" name="Aryan" time="2 days ago @5:30am" amount="36" />
                    <Withdraw status="subscribe" name="Aryan" time="2 days ago @5:30am" amount="36" /> */}
                    <EmptyScreen logo='transaction_a' heading='No transactions' description='There are no money transfers registered on your account.' />
                </div>
            </div>
        </div>
    )
}
